module.exports = __webpack_public_path__ + "static/media/undraw-focus-sey-6.d402c8e2.svg";